import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import HelpOutline from '@material-ui/icons/HelpOutline';
import ExitToApp from '@material-ui/icons/ExitToApp';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import useAuth from 'components/Auth/useAuth';
import useFunctions from 'components/Auth/useFunctions';
import useStore from 'components/Store/useStore';


const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(4),
  },
  spacing: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(3),
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    padding: theme.spacing(3),
  },
  bold: {
    fontWeight: 'bold'
  },
  answer: {
    marginLeft: theme.spacing(2)
  },
  buttons: {
    textAlign: "end"
  }
}));

export default function PaperForbidden(props)
{
  const classes = useStyles();
  const auth = useAuth();
  const [store, setStore] = useStore();

  const functions = useFunctions();
  const handleSignOut = React.useCallback(() => {
    functions.signOut();
    setStore({search:false, tab:0});
  }, [functions]);

  return (
    <Grid className={classes.container} container justifyContent="center">
      <Paper className={classes.paper}>
        <div style={{display: 'flex', alignItems: 'center', flexWrap: 'nowrap'}}>
          <HelpOutline color="primary" fontSize="large" /><Typography color="primary" variant="h5">ドキュメントが閲覧できません</Typography>
        </div>
        <Box m={1}/>
        <Typography paragraph>URLを受信したメールアドレスで再ログインをお願いします。</Typography>
        <Typography paragraph>ログイン中のメールアドレス：{auth.email}</Typography>
        <div className={classes.buttons}>
          <Button
              color="primary"
              variant="contained"
              onClick={handleSignOut}
              startIcon={<ExitToApp />}>
              ログアウト
            </Button>
        </div>
      </Paper>
    </Grid>
  );
}